export const getClampedEstimatedPoints = (drop) => {
    const { pointsLimit, estimatedPointsToEarn, pointsAwarded = 0, pointsReserved = 0, } = drop;
    if (!pointsLimit || !estimatedPointsToEarn) {
        return 0;
    }
    return Math.max(0, Math.round(Math.min(pointsLimit - pointsAwarded - pointsReserved, estimatedPointsToEarn)));
};
